import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDownWall"><Path d="M12.75 18.4395L16.5 14.6895L17.5605 15.75L12 21.3105L6.43945 15.75L7.5 14.6895L11.25 18.4395V7H12.75V18.4395Z" fill="currentColor"/><Path d="M20 4.5H4V3H20V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownWall;
